// extracted by mini-css-extract-plugin
export default {"modalRoot":"ANfjx","container":"px+sM","centered":"irsK3","content":"VSBUV","fromBottom":"+tRZH","fromRight":"_3AO5x"};